import React, { useState } from 'react'
import { images } from '../../constants'
import './Nav.css'

const Nav = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [isClosing, setIsClosing] = useState(false)

  const toggleNav = () => {
    if (isOpen) {
      setIsClosing(true)
      setTimeout(() => {
        setIsOpen(false)
        setIsClosing(false)
      }, 300)
    } else {
      setIsOpen(true)
    }
  }

  const handleLinkClick = () => {
    setIsClosing(true)
    setTimeout(() => {
      setIsOpen(false)
      setIsClosing(false)
    }, 300)
  }

  return (
    <nav
      className="navbar navbar-expand-sm navbar-dark mt-2"
      aria-label="Third navbar example"
    >
      <div className="container-fluid">
        <div>
          <a href="/">
            <img
              src={images.logo}
              alt="logo"
              style={{
                width: '50px',
                height: 'auto',
              }}
            />
          </a>
        </div>
        <div>
          <button
            className="navbar-toggler"
            type="button"
            onClick={toggleNav}
            aria-expanded={isOpen}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className={`collapse navbar-collapse fullscreen-nav ${
              isOpen ? 'show' : ''
            } ${isClosing ? 'closing' : ''}`}
          >
            <button
              className="close-btn"
              onClick={toggleNav}
            >
              &times;
            </button>
            <ul className="navbar-nav gap-3 mb-sm-0">
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="/"
                  onClick={handleLinkClick}
                >
                  Home
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="/about"
                  onClick={handleLinkClick}
                >
                  About
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="/menu"
                  onClick={handleLinkClick}
                >
                  Menu
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="/gallery"
                  onClick={handleLinkClick}
                >
                  Gallery
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="/contact-us"
                  onClick={handleLinkClick}
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Nav
